import React, { Component } from 'react';
import { Query } from '@apollo/react-components';
import { gql } from '@apollo/client';

const CONTENT_VIEWER = gql`
  query ContentViewer($input: ContentViewerInput!) {
    content(input: $input) {
      uuid
      markdown
      numItems
    }
  }
`;

class ContentPreloader extends Component {
  render() {
    const { uuid } = this.props;

    return (
      <Query query={CONTENT_VIEWER} variables={{ input: { uuid } }}>
        {() => {
          return null;
        }}
      </Query>
    );
  }
}

export default ContentPreloader;
